import React from "react";
import { MDBBtn, MDBContainer } from "mdb-react-ui-kit";
import { Link } from "react-router-dom";
import ebayLogo from "../assets/marketplaces/ebay.svg";

function EbayIntegratedPage() {
  return (
    <MDBContainer fluid className="py-5 px-3" style={{ minHeight: "100vh", background: "#f5f7ff" }}>
      <div className="mx-auto" style={{ maxWidth: "640px" }}>
        <div className="bg-white rounded-4 border shadow-sm p-4 p-md-5 text-center">
          <img src={ebayLogo} alt="eBay" className="mb-3" style={{ width: 56, height: 56, objectFit: "contain" }} />
          <h2 className="fw-bold mb-2">eBay is integrated</h2>
          <p className="text-muted mb-4">
            Your eBay account is linked. You can fine-tune listing defaults, shipping, and policies from eBay
            settings whenever you need to.
          </p>
          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <MDBBtn tag={Link} color="primary" to="/settings/ebay">
              Open eBay settings
            </MDBBtn>
            <MDBBtn tag={Link} color="light" to="/dashboard">
              Back to dashboard
            </MDBBtn>
          </div>
        </div>
      </div>
    </MDBContainer>
  );
}

export default EbayIntegratedPage;
